import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import { SBSizes } from "sonobello.utilities.react.mui";

import SchedulingStep, {
  ICenterInfoProps,
  ISchedulingStepConfig,
  ISchedulingStepProps,
  classNames
} from "./SchedulingStep";
import { ISchedulerProps } from "./SchedulingStepWrapper";

const FullAddressCenterInfo: React.FC<ICenterInfoProps> = ({ center, onClick }) => {
  const { streetAddress, cityStateZip } = center.addressParts;
  const centerInfo = (
    <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <LocationOnIcon sx={{ fontSize: SBSizes.icon }} />
      </Box>
      <Stack>
        <Typography variant="h6">{center.name}</Typography>
        <Typography variant="body2">{streetAddress}</Typography>
        {cityStateZip && (
          <Typography className={classNames.centerAddress2} variant="body2">
            {cityStateZip}
          </Typography>
        )}
        <Typography variant="body2">{center.phoneNumber}</Typography>
      </Stack>
      {onClick && <Button sx={{ fontSize: "0.7rem", p: 0 }}>Change</Button>}
    </Stack>
  );
  return onClick ? (
    <Box className={classNames.centerChangeButton} onClick={onClick} sx={{ cursor: "pointer" }}>
      {centerInfo}
    </Box>
  ) : (
    centerInfo
  );
};

/** Scheduling step that always shows the full center address regardless of viewport. */
const SchedulingStepWithAddress: React.FC<ISchedulingStepProps & ISchedulerProps & ISchedulingStepConfig> = props => (
  <SchedulingStep {...props} CenterInfo={FullAddressCenterInfo} />
);

export default SchedulingStepWithAddress;
